.mo-product-page {
  width: 100%;
  background: #F4F4F4;
  color: #9930E2;
  padding: 10px 7px;
  text-align: center;
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 460px;
  border: 1px solid #9930E2;
}

.mo-product-page p {
  font-family: 'Benton-Regular';
  text-align: left;
  font-size: 10px;
  line-height: 16px;
  margin: 0;
  margin-bottom: 4px;
  color: #073382;
}
.mo-product-page .mo-product-page__text{
  padding-right: 5px;
  width: 80%;
}
.mo-product-page .mo-product-page__text p:first-child{
  color: #9930E2;
  font-size: 13px;
}
.mo-product-page p b {
  font-family: 'Benton-Bold'
}
.mo-product-page p a{
  color: #9930e2;
  font-weight: bold;
  margin-left: 2px;
}
.mo-product-page__button {
  text-align: center;
}
.mo-product-page__image{
  width: 112px;
}
.mo-product-page__image img{
  width: 100%;
}
br {
  display: none;
}

@media (max-width: 528px) {
  .mo-product-page {
    max-width: 100%;
    width: inherit;
  }

}